import { AxiosResponse } from "axios";
import API from "../api";
import { LeadSource } from "../models/leadsource";

const ROUTE_NAME = "leads/sources/from";

const LeadSourceFromService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<LeadSource[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<LeadSource>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async create(leadSource: LeadSource): Promise<AxiosResponse<LeadSource>> {
    return await API.post(`/${ROUTE_NAME}`, leadSource);
  },
  async update(id: number, leadSource: LeadSource): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, leadSource);
  },
};

export default LeadSourceFromService;
